import { api } from "./api";

const baseUrl = "/user"; 

export const getUserInfo = async () => {
    return api.get(`${baseUrl}/userinfo`).then(res => res.data);
}